import clsx from 'clsx';

export const section = clsx(
  'px-10',
  'py-20',
  'md:px-48',
  'md:py-50',
  'bg-title',
);

export const image = clsx(
  'max-w-32',
  'md:max-w-xs',
  'object-contain',
  'self-center',
  'justify-center'
);

export const socialContainer = clsx(
  'flex',
  'items-center',
  'justify-between',
  'w-[100%]',
  'md:gap-0',
  'gap-10'
);

export const socialTitle = clsx(
  'title',
  'font-semibold',
  'md:text-lg',
  'text-sm',
  'text-background'
);

export const socialButtons = clsx('flex', 'gap-4', 'items-center');

export const socialButton = clsx(
  'bg-background',
  'flex',
  'items-center',
  'p-2',
  'md:p-3',
  'rounded-full',
  'shadow',
  'shadow-gray-600'
);

export const addressContainer = clsx(
  'flex',
  'flex-col',
  'gap-2',
  'md:mt-0',
  'mt-10',
);

export const addressTitle = clsx(
  'title',
  'text-background',
  'font-semibold',
  'md:text-lg',
  'text-sm'
);

export const addressText = clsx(
  'description',
  'md:text-sm',
  'text-[10px]',
  'text-background'
);

export const socialInnerContainer = clsx(
  'flex',
  'flex-col',
  'gap-2',
  'self-center'
);

export const addressInnerContainer = clsx('flex', 'gap-2', 'items-center', 'text-left');
